var _path, _path2, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSabah(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg834",
    width: 1200,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "rect824",
    d: "m0 0h600v400h-600z",
    fill: "#77ccff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path826",
    d: "m600 300h-600v-60c25.415516-3.88906 48.820143-24.03652 58.612112-39.66176 21.527093 0 41.041179-23.47236 62.500538-48.82014 3.95849-7.84755 9.79176-9.79176 19.58394-1.94449 7.7779 9.72233 9.72233 1.94449 13.68081-11.73639 1.94449-3.95849 5.83327-7.84755 9.72233-3.95849 5.90291 7.84755 7.84755 2.0139 13.68082-1.94448 9.79176-1.94449 23.47236-1.94449 33.26433 1.94448 5.83348-3.88906 15.62545-3.88906 25.34778-3.88906 7.84755 3.88906 15.62524 3.88906 23.47236 0 3.88906-1.94448 9.79176-3.88905 17.56988-3.88905 11.73639-9.79176 21.52709-19.51409 29.30605-15.62524 7.84755 1.94448 17.63931 3.88905 27.36291 3.88905 21.52709 0 33.26433-1.94448 39.09802-3.88905 3.88906 9.79175 5.83327 9.79175 7.77791 0 2.01389-5.90291 2.01389-9.79176 11.73639-11.736402 0-9.79175 3.95849-11.736392 11.73639-3.88906 11.7364 9.722332 25.41552 11.736402 39.09803 9.722332 0 11.7364 1.94449 11.7364 7.77791 0 1.94446-11.666962 9.79175-7.777902 21.52709 9.79176 1.94448 3.88906 3.88906 7.84755 3.88906 11.73639 42.98856 68.40409 76.38046 98.2062 123.25534 113.8996z",
    fill: "#002b7f",
    strokeWidth: 2.11672
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    id: "path828",
    d: "m600 200v200h600v-200z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect830",
    d: "m600 0h600v200h-600z",
    fill: "#0484d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect832",
    d: "m0 400h1200v200h-1200z",
    fill: "#f5362f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSabah);
export default __webpack_public_path__ + "static/media/sabah.fc31b9d2f3c4717fec48423a6e85103e.svg";
export { ForwardRef as ReactComponent };